import client, { FetchConfig } from '@/services/network/http'

class TransactionBaseApi {
  async post<T>(url: string, data?: Record<string, any>, options?: FetchConfig) {
    return client.post<T>(
      '/transaction/web/tx' + url,
      { bizContent: data ? { ...data } : {} },
      options
    )
  }
}

export default TransactionBaseApi
